import { ChainIds, ChainNamespaces } from "../../consts";

const commonConfig = {
  namespace: ChainNamespaces.EVM,
  symbol: "XTZ",
  buyTezUrl: "",
  tzktApiUrl: "",
  chain: ChainIds.ETHERLINK,
  decimals: 8,
};

export const etherlinkConfig = {
  mainnet: {
    name: "Etherlink",
    identifier: "42793",
    rpcUrl: "https://node.mainnet.etherlink.com",
    explorerUrl: "https://explorer.etherlink.com",
    ...commonConfig,
  },
  testnet: {
    name: "Etherlink Shadownet",
    identifier: "127823",
    rpcUrl: "https://node.shadownet.etherlink.com",
    explorerUrl: "https://shadownet.explorer.etherlink.com",
    isTestnet: true,
    ...commonConfig,
  },
} as const;
